import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from "../config/Params";
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { useParams, useNavigate } from 'react-router-dom'; 
import { Helmet } from 'react-helmet';
import { toast } from "react-toastify";

const ListingReportDetails = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [justification, setJustification] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const hostData = getItemFromLocalStorage('hostProfile');

  useEffect(() => {
    const fetchRatingData = async () => {
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.listingReports}`,
          data: formData,
        });

        if (response.data.items && Array.isArray(response.data.items)) {
          setReports(response.data.items);
        } else {
          console.log('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchRatingData();
  }, []);

  const matchingReport = reports.find(report => report.listing_report_id == reportId);
  
  useEffect(() => {
    if (reports.length > 0) {
      const matchingReport = reports.find(report => report.listing_report_id == reportId);
      if (matchingReport?.report_reply_from_host) {
        setJustification(matchingReport.report_reply_from_host);
      }
    }
  }, [reports, reportId]);

  const handleSubmitJustification = async () => {
    if (!justification.trim()) {
      toast.error("Please write your justification before submitting.");
      return;
    }

    setSubmitting(true);

    const formData = new FormData();
    formData.append("token", hostData.host_access_token);
    formData.append("reported_id", reportId);
    formData.append("justification", justification);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        url: `${params.baseURL}${params.endpoints.listingReportReply}`,
        data: formData,
      });

      if (response.data.status === 'ok') {
        toast.success("Your justification has been submitted successfully.");
        navigate('/listing-reports');
      } else {
        toast.error("Failed to submit. Please try again later.");
      }
    } catch (error) {
      console.error("API error:", error);
      toast.error("An error occurred while submitting.");
    }

    setSubmitting(false);
  };

  return (
    <div>
      <Helmet>
        <title>Listing Report Details</title>
        <meta name='description' content='Detailed view of listing report' />
      </Helmet>

      <div className='row'>
        <div className='col-md-6 m-auto'>
          <div className="ap-offer-section">
            <div className="apoffbx">
              {matchingReport ? (
                <div className='card mb-3 listing-report-box'>
                  <div className='category-img-sections'>
                    <div className="apimgcibox" style={{boxShadow:'none', padding:'0'}}>
                      <div className='image-wrapper lcibox' style={{ width: '100%' }}>
                        <div className='ac-cover-image'>
                          <img
                            src={matchingReport.cover_photo || '/assets/img/default_listing.jpg'}
                            alt={matchingReport.listing_title || 'Untitled Listing'}
                            className="ciso ap-ciso"
                            style={{ height: '180px' }}
                          />
                          <div className='aci-overlay'></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ padding: '20px', paddingTop: '0' }}>
                    <div className='category-data-header cat-pointer lrpntr'>
                      <img src={matchingReport.property_title_icon_image} alt="Icon" className="pointer-icon" />
                      <div>
                        <span className="cp-txt">
                            {
                                (() => {
                                const title = matchingReport.listing_title?.trim();
                                const text = title || 'Unknown Title';

                                const words = text.split(/\s+/);
                                return words.length > 3
                                    ? words.slice(0, 3).join(' ') + '...'
                                    : text;
                                })()
                            }
                        </span>
                        <span className="cp-txt" style={{marginLeft:'5px',color:'darkgrey'}}>
                            {
                            (() => {
                                const address = matchingReport.property_address?.trim() || '';
                                const limit = 20;

                                return address.length > limit
                                ? address.slice(0, limit) + '...'
                                : address;
                            })()
                            }
                        </span>
                      </div>
                    </div>
                    <div className='category-data-header cat-pointer lrpntr'>
                      <img src={'/assets/img/icons/common_point_icon.png'} alt="Icon" className="pointer-icon" />
                      <span className="cp-txt">
                        Reported on - {new Date(matchingReport.report_created_time).toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                        })}
                      </span>
                    </div>
                    <div className='category-data-header cat-pointer lrpntr'>
                      <img src={'/assets/img/icons/common_point_icon.png'} alt="Icon" className="pointer-icon" />
                      <span className="cp-txt">Reason - {matchingReport.report_reason_name}</span>
                    </div>
                    <div className='category-data-header cat-pointer lrpntr'>
                      <img src={'/assets/img/icons/common_point_icon.png'} alt="Icon" className="pointer-icon" />
                      <span className="cp-txt">
                        Description - {matchingReport.report_comment}
                      </span>
                    </div>

                    <div className="mt-4">
                      <div className="lrdtatxt">
                        <span>Write your justification on this report</span>
                      </div>

                      <textarea
                        className="form-control"
                        rows={5}
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                      ></textarea>
                      <button
                        className="co-host-box w-100 text-uppercase mt-3"
                        onClick={handleSubmitJustification}
                        disabled={submitting}
                      >
                        {submitting ? "Submitting..." : "Reply send to quality team"}
                      </button>
                    </div>

                  </div>
                </div>
              ) : (
                <div className="empty-chat-section ems">
                  <img src={'/assets/img/placeholder/no_rating_yet.svg'} className='empty-image img-fluid' alt='' />
                  <p>No report found for this ID.</p>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingReportDetails;
